import { FormControl } from '@mui/material';
import { HeaderFormParte } from './BBs/HeaderFormParte/HeaderFormParte';
import LinesContainer from './BBs/LinesContainer/LinesContainer';
import './FormParte.scss';
import AdjuntosPartesContainer from "./BBs/AdjuntosPartesContainer/AdjuntosPartesContainer";

export default function FormParte(props: any) {
  return (
    <FormControl className="parte-form" fullWidth>
      <HeaderFormParte
        allowFutureDate={props?.allowFutureDate}
        selectedobra={props?.selectedobra}
        presupuesto={props?.presupuesto}
        capitulos={props?.capitulos}
        lineas={props?.lineas}
        editable={props.editable}
        dateInvalid={props.dateInvalid}
        setDateInvalid={props.setDateInvalid}
        closedDays={props.closedDays}
        isCreation={props.isCreation}
        avisoData={props.avisoData}
        editMode={props.editMode}
      ></HeaderFormParte>
      {!!props?.headerOk && (
        <>
          <LinesContainer
            lineas={props?.lineas}
            editable={props.editable}
            data={props?.data}
            setSolapamiento={props?.setSolapamiento}
            solapamiento={props?.solapamiento}
            renderNewLine={props.editable}
          ></LinesContainer>
          <AdjuntosPartesContainer
            files={props.files}
            setFiles={props.setFiles}
            editable={props.editable}
            isView={!props.isCreation}
          />
        </>
      )}
    </FormControl>
  );
}
